// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animate-element{
    visibility: hidden;
    animation: hero .5s linear forwards;
}
@keyframes hero {
    0%{
        transform: translateY(100px);
        visibility: visible;
    }
    100%{
        transform: translateY(0);
        visibility: visible;
    }
}
a{
    font-family: 'Arial';
    font-style: normal;
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 2rem;
    text-decoration: none;
    text-transform: capitalize;
    color: inherit;
}
a:hover{
    color: var(--t-lgrey);
}
.Bannerheader{
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 300;
    height: 7rem;
    transition: .5s all linear;
    color: var(--white);
    z-index: 11;
    background-color: rgba(0,0,0,0.6);
}
.Bannerheader>*{
    z-index: 11;
}

.header_left{
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    margin-left: 2rem;
}
.header_left> a > img{
    width: 10rem;
    display: block;
}
.header_right{
    display: flex;
    margin-right: 2rem;
    color: white;
}
@media only screen and (max-width: 1200px) {
    .Bannerheader{
        padding: 0rem 1rem 0rem 1rem;
        gap: 1rem;
    }
}


@media only screen and (max-width: 1025px) {
    .Bannerheader{
        padding: 0rem 2rem 0rem 1rem;
    }
    .header_right{
        margin-right: 1rem;
    }
    
}
@media only screen and (max-width: 550px) {
    .Bannerheader {
        padding: 0rem 1rem 0rem 1rem;
        gap: 0.5rem;
    }
    .header_left{
        gap: 0.5rem;
        margin-left: 1rem;
    }
    .header_left> a > img{
        width:7rem;
    }
    .header_left>h6{
        font-size:0.9rem !important;
    }
    .smallPadding{
        padding:0.62rem 1.71rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;AACA;IACI;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;IACA;QACI,wBAAwB;QACxB,mBAAmB;IACvB;AACJ;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,iCAAiC;AACrC;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,cAAc;AAClB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI;QACI,4BAA4B;QAC5B,SAAS;IACb;AACJ;;;AAGA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,kBAAkB;IACtB;;AAEJ;AACA;IACI;QACI,4BAA4B;QAC5B,WAAW;IACf;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,UAAU;IACd;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".animate-element{\n    visibility: hidden;\n    animation: hero .5s linear forwards;\n}\n@keyframes hero {\n    0%{\n        transform: translateY(100px);\n        visibility: visible;\n    }\n    100%{\n        transform: translateY(0);\n        visibility: visible;\n    }\n}\na{\n    font-family: 'Arial';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1.2rem;\n    line-height: 2rem;\n    text-decoration: none;\n    text-transform: capitalize;\n    color: inherit;\n}\na:hover{\n    color: var(--t-lgrey);\n}\n.Bannerheader{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 300;\n    height: 7rem;\n    transition: .5s all linear;\n    color: var(--white);\n    z-index: 11;\n    background-color: rgba(0,0,0,0.6);\n}\n.Bannerheader>*{\n    z-index: 11;\n}\n\n.header_left{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    margin-left: 2rem;\n}\n.header_left> a > img{\n    width: 10rem;\n    display: block;\n}\n.header_right{\n    display: flex;\n    margin-right: 2rem;\n    color: white;\n}\n@media only screen and (max-width: 1200px) {\n    .Bannerheader{\n        padding: 0rem 1rem 0rem 1rem;\n        gap: 1rem;\n    }\n}\n\n\n@media only screen and (max-width: 1025px) {\n    .Bannerheader{\n        padding: 0rem 2rem 0rem 1rem;\n    }\n    .header_right{\n        margin-right: 1rem;\n    }\n    \n}\n@media only screen and (max-width: 550px) {\n    .Bannerheader {\n        padding: 0rem 1rem 0rem 1rem;\n        gap: 0.5rem;\n    }\n    .header_left{\n        gap: 0.5rem;\n        margin-left: 1rem;\n    }\n    .header_left> a > img{\n        width:7rem;\n    }\n    .header_left>h6{\n        font-size:0.9rem !important;\n    }\n    .smallPadding{\n        padding:0.62rem 1.71rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
